import { authClient } from "@/shared/lib/axios";
import { rootRoute } from "@/routes";
import { Spinner, VStack } from "@/shared/ui/primitives";
import { createRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";

function OAuthSolapiPage() {
	const navigate = useNavigate();
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		let cancelled = false;
		const currentUrl = `${window.location.pathname}${window.location.search}`;
		const params = new URLSearchParams(window.location.search);
		const returnUrl = params.get("returnUrl");
		const popup = params.get("popup");

		if (returnUrl?.startsWith("/")) {
			sessionStorage.setItem("oauth_return_url", returnUrl);
		}
		if (popup === "1") {
			sessionStorage.setItem("oauth_popup_mode", "1");
		} else {
			sessionStorage.removeItem("oauth_popup_mode");
		}

		void authClient
			.get<{ url?: string; error?: string }>("/oauth/solapi/auth-url")
			.then(({ data }) => {
				if (cancelled) return;
				if (data.url) {
					window.location.href = data.url;
					return;
				}
				setError(data.error ?? "Solapi 연동 URL을 가져오지 못했습니다.");
			})
			.catch(() => {
				if (cancelled) return;
				navigate({ to: "/login", search: { returnUrl: currentUrl } });
			});

		return () => {
			cancelled = true;
		};
	}, [navigate]);

	if (error) {
		return (
			<VStack className="min-h-screen items-center justify-center gap-4 p-4">
				<span className="text-ct-strong font-medium">{error}</span>
				<a href="/" className="text-pm-strong text-sm underline">
					홈으로
				</a>
			</VStack>
		);
	}

	return (
		<VStack className="min-h-screen items-center justify-center gap-4 p-4">
			<Spinner size="md" />
			<span className="text-ct-regular text-sm">Solapi 연동 페이지로 이동 중...</span>
		</VStack>
	);
}

export const oauthSolapiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/oauth/solapi",
	component: OAuthSolapiPage,
});
